export default {
    list: [
        {
            id: 1,
            title: 'components.faq.list.0.title',
            description: 'components.faq.list.0.description',
            isActive: true,
          },
          {
            id: 2,
            title: 'components.faq.list.1.title',
            description: 'components.faq.list.1.description',
            isActive: true,
          },
          {
            id: 3,
            title: 'components.faq.list.2.title',
            description: 'components.faq.list.2.description',
            isActive: true,
          },
          {
            id: 4,
            title: 'components.faq.list.3.title',
            description: 'components.faq.list.3.description',
            isActive: true,
          },
          {
            id: 5,
            title: 'components.faq.list.4.title',
            description: 'components.faq.list.4.description',
            isActive: true,
          },
          {
            id: 6,
            title: 'components.faq.list.5.title',
            description: 'components.faq.list.5.description',
            isActive: true,
          },
          {
            id: 7,
            title: 'components.faq.list.6.title',
            description: 'components.faq.list.6.description',
            isActive: true,
          },
          {
            id: 8,
            title: 'components.faq.list.7.title',
            description: 'components.faq.list.7.description',
            isActive: true,
          },
          {
            id: 9,
            title: 'components.faq.list.8.title',
            description: 'components.faq.list.8.description',
            isActive: true,
          },
          {
            id: 10,
            title: 'components.faq.list.9.title',
            description: 'components.faq.list.9.description',
            isActive: true,
          },
          {
            id: 11,
            title: 'components.faq.list.10.title',
            description: 'components.faq.list.10.description',
            isActive: true,
          },
          {
            id: 12,
            title: 'components.faq.list.11.title',
            description: 'components.faq.list.11.description',
            isActive: true,
          },
          {
            id: 13,
            title: 'components.faq.list.12.title',
            description: 'components.faq.list.12.description',
            isActive: true,
          },
          {
            id: 14,
            title: 'components.faq.list.13.title',
            description: 'components.faq.list.13.description',
            isActive: true,
          },
          {
            id: 15,
            title: 'components.faq.list.14.title',
            description: 'components.faq.list.14.description',
            isActive: true,
          },
          {
            id: 16,
            title: 'components.faq.list.15.title',
            description: 'components.faq.list.15.description',
            isActive: true,
          },
          {
            id: 17,
            title: 'components.faq.list.16.title',
            description: 'components.faq.list.16.description',
            isActive: true,
          },
          {
            id: 18,
            title: 'components.faq.list.17.title',
            description: 'components.faq.list.17.description',
            isActive: true,
          },
          {
            id: 19,
            title: 'components.faq.list.18.title',
            description: 'components.faq.list.18.description',
            isActive: true,
          },
        {
            id: 20,
            title: 'components.faq.list.19.title',
            description: 'components.faq.list.19.description',
            isActive: true,
        },
        {
            id: 21,
            title: 'components.faq.list.20.title',
            description: 'components.faq.list.20.description',
            isActive: true,
        },
        {
            id: 22,
            title: 'components.faq.list.21.title',
            description: 'components.faq.list.21.description',
            isActive: true,
        },
        {
            id: 23,
            title: 'components.faq.list.22.title',
            description: 'components.faq.list.22.description',
            isActive: true,
        },
        {
            id: 24,
            title: 'components.faq.list.23.title',
            description: 'components.faq.list.23.description',
            isActive: true,
        },
    ],
};
